import { useReadAccess } from 'src/app/AppAuth/useReadAccess'
import React from 'react'
import { GridHeader, GridRow } from 'src/components/Reusable/Grid'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { IsGatekeeperEnabled, GatekeeperFlag } from 'src/context/Gatekeeper'
import {
  getControlsListItemConfig,
  useShowControlRiskColumn,
} from '../../IndexItem/ControlsListItem.helpers'
import { ControlListItemConfig } from '../../IndexItem/ControlListItem.constants'
import { ControlsGridHeader } from './ControlsIndexGrid.styles'
import {
  ControlsIndexGridOwnerHeader,
  ControlsIndexGridOperatingEffectivenessHeader,
  ControlsIndexGridDepartmentHeader,
  ControlsIndexGridFrameworksHeader,
  ControlsIndexGridIdHeader,
  ControlsIndexGridLinkedEvidenceHeader,
  ControlsIndexGridNameHeader,
  ControlsIndexGridStatusHeader,
  ControlsIndexGridLabelsHeader,
  ControlsIndexGridRisksHeader,
} from './ControlsIndexGrid.components'

export const ControlsIndexGridHeader = ({
  config,
  showContentMatchColumn,
}: {
  config?: ControlListItemConfig
  showContentMatchColumn?: boolean
}): JSX.Element => {
  const canViewAuditScans = useReadAccess(CAPABILITY.CAN_VIEW_AUDIT_SCANS)
  const {
    showDepartmentColumn,
    showModelIdColumn,
    showControlNameColumn,
    showFrameworkColumn,
    showOperatingEffectivenessColumn,
    showLinkedEvidenceColumn,
    showStatusColumn,
    showOwnerColumn,
    showMenuColumn,
  } = getControlsListItemConfig(config)
  const showRiskColumn = useShowControlRiskColumn(config)

  const showLabels = IsGatekeeperEnabled(GatekeeperFlag.LABELS)

  const showOperatingEffectiveness =
    canViewAuditScans && showOperatingEffectivenessColumn

  return (
    <GridRow>
      {showContentMatchColumn && <GridHeader />}
      {showDepartmentColumn && <ControlsIndexGridDepartmentHeader />}
      {showModelIdColumn && <ControlsIndexGridIdHeader />}
      {showControlNameColumn && <ControlsIndexGridNameHeader />}
      {showLabels && <ControlsIndexGridLabelsHeader />}
      {showRiskColumn && <ControlsIndexGridRisksHeader />}
      {showFrameworkColumn && <ControlsIndexGridFrameworksHeader />}
      {showLinkedEvidenceColumn && <ControlsIndexGridLinkedEvidenceHeader />}
      {showOperatingEffectiveness && (
        <ControlsIndexGridOperatingEffectivenessHeader />
      )}
      {showStatusColumn && <ControlsIndexGridStatusHeader />}
      {showOwnerColumn && <ControlsIndexGridOwnerHeader />}
      {showOwnerColumn && (
        <ControlsGridHeader justifyContent="flex-start">
          Assignees
        </ControlsGridHeader>
      )}
      {showMenuColumn && <ControlsGridHeader />}
    </GridRow>
  )
}
